/// <reference types="vite/client" />
/**
 * The API endpoint baked into this build as the absent-attribute default.
 *
 * Read at CALL time, never at import time: a real build statically
 * replaces the env read with a literal (the deploy pipeline sets
 * VITE_STEWARD_API_ENDPOINT per environment, so each published bundle
 * carries its own default and the bundles are no longer byte-identical
 * across environments), while the test suite varies the value per-case
 * with vi.stubEnv. An empty value means this build ships no default —
 * <steward-chat> then requires an explicit api-endpoint attribute.
 */
export function bakedApiEndpoint(): string {
  return import.meta.env.VITE_STEWARD_API_ENDPOINT ?? '';
}
